<script lang="ts">
import Vue, { CreateElement, RenderContext, VNode } from 'vue';

import { Nullable } from '@/utils/types';
import { formatJSDate } from '@/utils/filters';

interface IProps {
  leaseCommencement: Nullable<string>;
  leaseExpiration: Nullable<string>;
}

export default Vue.extend({
  name: 'LeaseCommencementExpirationLabel',

  functional: true,

  props: {
    leaseCommencement: {
      type: String,
      default: null,
    },
    leaseExpiration: {
      type: String,
      default: null,
    },
  },

  render (h: CreateElement, context: RenderContext<IProps>): VNode {
    const { leaseCommencement, leaseExpiration } = context.props;

    let displayText: string;

    if (!leaseCommencement && !leaseExpiration) {
      // Both are null -> N/A
      displayText = 'N/A';
    } else if (leaseCommencement && leaseExpiration) {
      // Both present -> {{ lease-commencement }} - {{ lease-expiration }}
      displayText = `${formatJSDate(leaseCommencement)} - ${formatJSDate(leaseExpiration)}`;
    } else if (leaseCommencement && !leaseExpiration) {
      // lease-commencement has value and lease-expiration doesn't -> {{ lease-commencement }}
      displayText = formatJSDate(leaseCommencement) as string;
    } else {
      // lease-commencement hasn't value and lease-expiration has -> N/A - {{ lease-expiration }}
      displayText = `N/A - ${formatJSDate(leaseExpiration)}`;
    }

    return h('span', displayText);
  },
});
</script>
